<template>
    <div>
        <v-card>
            <v-card-title>Add Vanglaini Thlalak</v-card-title>
            <v-divider/>
            <v-card-text>
                <v-form ref="form" v-model="isValid">
                    <v-text-field
                        filled
                        label="Photographer's name"
                        v-bind:rules="validation.photographer_name"
                        v-model="serverData.photographer_name"
                        @change="onNameChange($event)"
                    ></v-text-field>
                    <br>
                    <v-textarea
                        rows="3"
                        filled
                        label="Address"
                        v-model="serverData.address"
                        @change="onAddressChange($event)"
                    >
                    </v-textarea>
                    <v-textarea
                        rows="4"
                        filled
                        label="Description"
                        v-model="serverData.description"
                        @change="onDescriptionChange($event)"
                    >
                    </v-textarea>
                    <v-file-input
                        filled
                        label="Photo"
                        accept="image/*"
                        prepend-icon="mdi-camera"
                        :rules="validation.image"
                        v-model="serverData.photo"
                        show-size
                        counter
                    ></v-file-input>
                    <v-text-field
                      label="Select publish date"
                      filled
                      clearable
                      readonly
                      :rules="validation.publishDate"
                      v-model="formattedDate"
                      @click:clear="dateClearCallback"
                      prepend-icon="mdi-calendar"
                      @click="showDatePicker"
                    ></v-text-field>
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>

                <v-btn
                    tile
                    color="primary"
                    class="mx-2"
                    v-on:click="submit"
                    v-bind:disabled="!isValid"
                    v-bind:loading="loading"
                    >Submit</v-btn
                >
                <v-spacer />
            </v-card-actions>
        </v-card>
        <DatePickerDialog @dateSelected="dateSelectionCallback" :visible="showDatePickerDialog" @close="showDatePickerDialog=false"></DatePickerDialog>

    </div>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import vtApi from '@/api/vtApi'
import snackbar from '@/utils/snackbar'
import dateUtils from '@/utils/dateUtils'
import DatePickerDialog from '@/components/DatePickerDialog'
import commonUtils from '@/utils/commonUtils'
export default {
  components: {
    DatePickerDialog
  },
  props: {
    title: {
      type: String,
      default: 'Add News'
    }
  },

  data () {
    return {
      isValid: null,
      imageData: '',
      loading: false,
      formattedDate: null,
      showDatePickerDialog: false,
      serverData: {
        photographer_name: '',
        address: '',
        description: null,
        publish_date: null,
        photo: null
      },
      validation: {
        photographer_name: [(v) => !!v || 'Please enter Photographer\'s name'],
        publishDate: [(v) => !!v || 'Please enter publish date'],
        image: [(v) => !!v || 'Please add Photo']
      },
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'link'],
            [{ header: 1 }, { header: 2 }],
            [{ align: [] }],
            ['clean'],
            [{ list: 'ordered' }, { list: 'bullet' }]]
        },
        placeholder: 'Body'
      }
    }
  },
  watch: {
    'serverData.photographer_name': function (newVal, oldVal) {
      if (newVal && newVal[newVal.length - 1] === '\\') {
        this.serverData.photographer_name = oldVal !== null ? oldVal + 'ṭ' : 'ṭ'
      } else if (newVal && newVal[newVal.length - 1] === '|') {
        this.serverData.photographer_name = oldVal !== null ? oldVal + 'Ṭ' : 'Ṭ'
      }
    },
    'serverData.address': function (newVal, oldVal) {
      if (newVal && newVal[newVal.length - 1] === '\\') {
        this.serverData.address = oldVal !== null ? oldVal + 'ṭ' : 'ṭ'
      } else if (newVal && newVal[newVal.length - 1] === '|') {
        this.serverData.address = oldVal !== null ? oldVal + 'Ṭ' : 'Ṭ'
      }
    },
    'serverData.description': function (newVal, oldVal) {
      if (newVal && newVal[newVal.length - 1] === '\\') {
        this.serverData.description = oldVal !== null ? oldVal + 'ṭ' : 'ṭ'
      } else if (newVal && newVal[newVal.length - 1] === '|') {
        this.serverData.description = oldVal !== null ? oldVal + 'Ṭ' : 'Ṭ'
      }
    }
  },
  methods: {

    dateClearCallback () {
      this.$log.info('date clear callback')
      this.serverData.publish_date = null
    },
    dateSelectionCallback (data) {
      this.$log.info('date selection callback', [data])
      this.formattedDate = data
      this.serverData.publish_date = dateUtils.parseDate(data)
    },
    showDatePicker () {
      this.showDatePickerDialog = true
    },
    async submit () {
      this.loading = true
      try {
        this.$log.info('vThlalak submit params', [this.serverData])
        const response = await vtApi.add(this.serverData)
        if (response.data !== undefined) {
          if (response.data.id !== undefined) {
            this.$refs.form.reset()
            snackbar.show('Vanglaini thlalak added successfully', 'success')
            window.publish_date = this.serverData.publish_date
            this.$router.push({ path: '/vanglaini-thlalak', replace: true })
          }
        }
      } finally {
        this.loading = false
      }
    },
    onEditorBlur (quill) {
    },
    onEditorFocus (quill) {
    },
    onEditorReady (quill) {
    },
    onEditorChange ({ quill, html, text }) {
      this.content = html
    },
    onNameChange (newVal, oldVal) {
      this.serverData.photographer_name = commonUtils.parseStringForTri(newVal)
    },
    onAddressChange (newVal, oldVal) {
      this.serverData.address = commonUtils.parseStringForTri(newVal)
    },
    onDescriptionChange (newVal, oldVal) {
      this.serverData.description = commonUtils.parseStringForTri(newVal)
    }
  }
}
</script>

<style>
.ql-editor{
  min-height: 350px;
}
</style>
